import request from '@/utils/request'

export function listRechargeOrders(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recharge.listUserRechargeOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function exportRechargeOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function importRechargeOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/importRechargeOrder',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error.response.data)
    })
  })
}

// 充值订单退款
export function refundRechargeOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recharge.refundRechargeOrder',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error.response.data)
    })
  })
}

// 标记充值成功（充值处理中 → 充值成功）
export function finishRechargeOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recharge.finishRechargeOrder',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error.response.data)
    })
  })
}